import { ContractOperationLogItemDTO } from '../../dto/contractOperationLog/ContractOperationLogDTO'

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/
const ISO_DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/

export const EMPTY = '—'

export function formatDate(value: string | null): string {
  const match = value ? ISO_DATE.exec(value) : null
  if (!match) return EMPTY
  const [, year, month, day] = match
  return `${day}/${month}/${year}`
}

export function formatDateTime(value: string | null): string {
  const match = value ? ISO_DATE_TIME.exec(value) : null
  if (!match) return EMPTY
  const [, year, month, day, hour, minute] = match
  return `${day}/${month}/${year} ${hour}:${minute}`
}

export function describeCounts(operation: ContractOperationLogItemDTO): string {
  if (operation.qtyTotal === 0) return 'Sin contratos'
  const applied = `${operation.qtyOk} ${operation.qtyOk === 1 ? 'aplicado' : 'aplicados'}`
  return operation.qtyNotProcessed === 0 ? applied : `${applied}, ${operation.qtyNotProcessed} sin aplicar`
}
